import { ColDef, GridOptions } from 'ag-grid-community'
import { Locale, Translation } from 'locale'
import { gridOptionsBase, TypedValueGetterParams, ValidationCellRenderer } from 'view/components/datagrid'
import { productPermissionFormatter } from '../datagrid'
import { TradingEntityProduct, TradingEntityProductFields } from './validateTradingEntityProductParseResult'

enum PendingTradingEntityProductGridColumnId {
  ORGANISATION_SHORT_CODE = 'ORGANISATION_SHORT_CODE',
  TRADING_ENTITY_SHORT_NAME = 'TRADING_ENTITY_SHORT_NAME',
  PRODUCT = 'PRODUCT',
  SECTOR = 'SECTOR',
  PERMISSION = 'PERMISSION'
}

export const PendingTradingEntityProductColumnDefs: ColDef[] = [
  {
    colId: PendingTradingEntityProductGridColumnId.ORGANISATION_SHORT_CODE,
    valueGetter: (params: TypedValueGetterParams<TradingEntityProduct>) => params.data?.orgShortCode,
    headerName: Locale.translate(Translation.TC_ORGANISATION_SHORT_CODE),
    width: 160,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingEntityProductFields.ORGANISATION_SHORT_CODE
    }
  },
  {
    colId: PendingTradingEntityProductGridColumnId.TRADING_ENTITY_SHORT_NAME,
    valueGetter: (params: TypedValueGetterParams<TradingEntityProduct>) => params.data?.shortName,
    headerName: Locale.translate(Translation.TC_TRADING_ENTITY_SHORT_NAME),
    width: 170,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingEntityProductFields.TRADING_ENTITY_SHORT_NAME
    }
  },
  {
    colId: PendingTradingEntityProductGridColumnId.PRODUCT,
    valueGetter: (params: TypedValueGetterParams<TradingEntityProduct>) => params.data?.productName,
    headerName: Locale.translate(Translation.TC_PRODUCT),
    width: 120,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingEntityProductFields.PRODUCT
    }
  },

  {
    colId: PendingTradingEntityProductGridColumnId.SECTOR,
    valueGetter: (params: TypedValueGetterParams<TradingEntityProduct>) => params.data?.sectorName,
    headerName: Locale.translate(Translation.TC_SECTOR),
    width: 120,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingEntityProductFields.SECTOR
    }
  },
  {
    colId: PendingTradingEntityProductGridColumnId.PERMISSION,
    valueGetter: (params: TypedValueGetterParams<TradingEntityProduct>) => params.data?.permission,
    headerName: Locale.translate(Translation.TC_PERMISSION),
    width: 120,
    cellRenderer: ValidationCellRenderer,
    cellRendererParams: {
      validationField: TradingEntityProductFields.PERMISSION
    },
    valueFormatter: productPermissionFormatter
  }
]

export const pendingTradingEntityProductGridOptions: GridOptions = {
  ...gridOptionsBase,
  getRowId: ({ data }) => data.idx
}
